import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { Condition } from "src/app/models/custom-types";
import { CajaDTO } from "src/app/models/dto/caja.dto";
import { FilterEvent } from "src/app/models/filter";
import { ListAction } from "src/app/models/list-actions.model";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { LayoutsService } from "src/app/services/layouts.service";
import { Filter } from "src/app/shared/classes/filter";
import Swal from "sweetalert2";
import { CajaService } from "./caja.service";
import { CajaFormComponent } from "./form/form.component";
import { CajaModalComponent } from "./modal/modal.component";

@Component({
  selector: "app-caja",
  templateUrl: "./caja.component.html",
  styleUrls: [],
})
export class CajaComponent implements OnInit {
  columnId: string = "IdEmpresa";
  public columns: ListColumn[] = [
    {
      name: "Nombre",
      property: "Nombre",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Saldo",
      property: "Saldo",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];

  public actions: ListAction<CajaDTO>[] = [
    {
      desc: "Ver historial",
      action: "see",
      visible: () => true,
    },
    {
      desc: "Agregar movimiento",
      action: "update",
      visible: () => true,
    },
  ];

  filtro: string = "";
  realdata: CajaDTO[];

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;
  constructor(
    public service: CajaService,
    public layoutService: LayoutsService,
    public dialog: MatDialog,
    public alerts: AlertasSwalService
  ) {}
  ngOnInit(): void {
    this.loadRecords();
    this.filter = new Filter<CajaDTO>(this.conditions, this.columns, true);
  }
  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData;
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  //#region Filter
  public filter: Filter<CajaDTO>;
  public conditions: Condition<CajaDTO> = {
    Nombre: (o, f) => o.Nombre.toLocaleLowerCase().indexOf(f) > -1,
    Saldo: (o, f) =>
      (o.Saldo ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter

  actionstable(e: { action: string; row: CajaDTO }) {
    if (e.action == "update") {
      this.openEntry(e.row);
    } else if (e.action == "see") {
      this.opendialoghistorial(e.row.IdTrabajador);
    }
  }

  async opendialoghistorial(id) {
    await this.dialog
      .open(CajaModalComponent, {
        panelClass: ["modal-for-table", "w-full", "lg:w-1/2"],
        data: {
          IdTrabajador: id,
        },
      })
      .afterClosed()
      .toPromise();

    this.loadRecords();
  }

  async openEntry(row) {
    const result = await this.dialog
      .open(CajaFormComponent, {
        panelClass: ["w-full", "lg:w-1/2"],
        data: {
          title: "Movimiento para " + row.Nombre,
          IdTrabajador: row.IdTrabajador,
        },
      })
      .afterClosed()
      .toPromise();

    if (result) {
      this.service.add(result).subscribe(
        (event) => {
          this.alerts.correcta("Correcto", "Movimiento registrado");
          this.loadRecords();
        },
        (err) => {
          this.alerts.error("Error", err.error.Message);
        }
      );
    }
  }
}
